// import axios from 'axios';

export const getSecondSession = () => {
  return Promise.resolve(false);
}